export const SCHEDULE_TYPES = {
  SAME: 'same',
  DIFFERENT: 'different',
};
